import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AnyAction, Dispatch } from 'redux';
import { ClickOutsideWrapper, Constants, Icons, MenuItem, Text } from '@shared/ui-components';

import { AbilityAwareProps, withAbilityContext } from 'common/ability/with-ability-context';
import { THEMES_DIALOG_NAME } from 'common/components/page-header-avatar';
import { SubscriptionType } from 'common/constants/subscription';
import { ColorsName } from 'common/enums/kreo-colors';
import { State } from 'common/interfaces/state';
import { KreoDialogActions } from 'common/UIKit';
import { AppUrls } from 'routes/app-urls';
import { ThemeType } from '../../../../components/theme-provider/interfaces';
import { CompanySubscriptionModel } from '../../../../units/account/interfaces/company-subscription-model';
import { AccountSelectors } from '../../../../units/account/selectors';
import { PersistedStorageActions } from '../../../../units/persisted-storage/actions/creators';
import { Styled } from './styled';

interface ReduxActions {
  goTo: (path: string) => void;
  setTheme: (theme: ThemeType) => void;
  openThemesDialog: () => void;
}

interface StateProps {
  nightVersion: boolean;
  subscription: CompanySubscriptionModel;
}

interface Props extends ReduxActions, StateProps, AbilityAwareProps {
  userName: string;
  fullName: string;
  logOut: () => void;
  onClose: () => void;
  isAdminPage?: boolean;
}

class PageHeaderAvatarMenuComponent extends React.Component<Props> {

  public render(): JSX.Element {
    return (
      <ClickOutsideWrapper onExit={this.props.onClose}>
        <Styled.Container id='avatar-menu'>
          <Styled.Header>
            <Text textTransform='Capitalize'>{this.props.fullName}</Text>
            <Text
              color={ColorsName.additionalFont}
              fontSize={12}
            >
              {this.props.userName}
            </Text>
          </Styled.Header>
          <Styled.Main>
            <MenuItem
              Icon={Icons.Username}
              text='Account'
              onClick={this.onAccountClick}
              fontSize={14}
              withBorder={true}
            />
            <MenuItem
              Icon={Icons.Team2D}
              text='Manage Users'
              onClick={this.onManageUsersClick}
              fontSize={14}
              withBorder={true}
            />
            <MenuItem
              Icon={Icons.Plan}
              text='Manage Subscription'
              onClick={this.onManageSubscriptionClick}
              fontSize={14}
              withBorder={true}
            />
            <MenuItem
              Icon={Icons.Exit}
              text='Exit'
              onClick={this.props.logOut}
              fontSize={14}
              withBorder={true}
            />
          </Styled.Main>
        </Styled.Container>
      </ClickOutsideWrapper>
    );
  }

  @autobind
  private onAccountClick(): void {
    this.props.goTo(AppUrls.account.manage.url());
    this.props.onClose();
  }

  @autobind
  private onManageUsersClick(): void {
    this.props.goTo(AppUrls.subscription.manageCompanySubscription.url({ type: SubscriptionType.Modular }));
    this.props.onClose();
  }

  @autobind
  private onManageSubscriptionClick(): void {
    this.props.goTo(AppUrls.subscription.index.url({ type: SubscriptionType.Modular }));
    this.props.onClose();
  }
}

function mapStateToProps(state: State): StateProps {
  return {
    nightVersion: state.persistedStorage.theme === Constants.Theme.DARK_THEME.name,
    subscription: AccountSelectors.currentSubscription(state),
  };
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ReduxActions => {
  return {
    setTheme: (theme) => dispatch(PersistedStorageActions.setTheme(theme)),
    goTo: path => dispatch(push(path)),
    openThemesDialog: () => dispatch(KreoDialogActions.openDialog(THEMES_DIALOG_NAME)),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export const PageHeaderAvatarMenu = connector(withAbilityContext(PageHeaderAvatarMenuComponent));
